export default __webpack_public_path__ + "static/media/discoverDashboard.4b11ae0d.png";